// Breadcrumbs.js
import React from "react";
import { useLocation, Link } from "react-router-dom";
import routes from "../../Route/router"; // 导入路由配置
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
const blackList = [
  "/about",
  "/prodandsolution",
  "/join",
  "/service",
  "/prodandsolution/solution",
  "/news"
];

function findChineseName(routePath, routesConfig) {
  for (let i = 0; i < routesConfig.length; i++) {
    const route = routesConfig[i];
    if (route.path === routePath) {
      return route.name || "";
    }
    if (route.children) {
      const childResult = findChineseName(routePath, route.children);
      if (childResult) {
        return childResult;
      }
    }
  }
  return "";
}

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className={css.icon}></div>
      <div className={css.item} style={{ paddingLeft: "0" }}>
        <Link to="/">{t("首页")}</Link>
      </div>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        if (blackList.includes(routeTo)) {
          return "";
        }
        // 获取中文名称
        const chineseName = findChineseName(routeTo, routes);

        return (
          <div key={name} className={`${css.item} ${css.arrow}`}>
            {isLast ? (
              <span>{t(chineseName || name)}</span>
            ) : (
              <Link to={routeTo}>{t(chineseName || name)}</Link>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Breadcrumbs;
